$(document).ready(function() {

  if ($('section.profile').length) {
    checkForCompletion();
  }

  // Check for all profile sections complete
  function checkForCompletion() {
    var completeSections = 0;
    var totalSections = $('.profile .card').length
    $('.profile .card').each(function() {
      if ($(this).hasClass('complete')) {
        completeSections++;
      }
    });

    if (completeSections == totalSections) {
      $('.profile').find('.bttn-submit').attr('disabled', false)
    }
  }

});
